import {
  STRING_getInstance7xungxdjbzv as STRING_getInstance,
  INT_getInstance32g3l1d0jirwg as INT_getInstance,
  BOOLEAN_getInstancewc2j8mltq0p1 as BOOLEAN_getInstance,
  DOUBLE_getInstance26ldxisjb14a2 as DOUBLE_getInstance,
  LONG_getInstance2g4gwhhf21sqr as LONG_getInstance,
  BYTE_getInstance19ddfopm3uuty as BYTE_getInstance,
  SHORT_getInstancext99ki650964 as SHORT_getInstance,
  FLOAT_getInstance2yidggfln26xa as FLOAT_getInstance,
  CHAR_getInstance38268mv2tvqra as CHAR_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
import {
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from './ObjectSerializer.mjs';
import { initBuiltins3cd82qqvse108 as initBuiltins } from './Platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
var StringSerializerClass;
function StringSerializer() {
  if (StringSerializerClass === VOID) {
    class $ {
      constructor() {
        StringSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.String', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_jnz9c3_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_jnz9c3_k$(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeString_x3hxsx_k$();
      }
    }
    initMetadataForObject($, 'StringSerializer', VOID, VOID, [KSerializer()]);
    StringSerializerClass = $;
  }
  return StringSerializerClass;
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new (StringSerializer())();
  return StringSerializer_instance;
}
var IntSerializerClass;
function IntSerializer() {
  if (IntSerializerClass === VOID) {
    class $ {
      constructor() {
        IntSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Int', INT_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_iz3ntn_k$(encoder, value) {
        return encoder.encodeInt_y5zi3z_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_iz3ntn_k$(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeInt_8iq8f5_k$();
      }
    }
    initMetadataForObject($, 'IntSerializer', VOID, VOID, [KSerializer()]);
    IntSerializerClass = $;
  }
  return IntSerializerClass;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new (IntSerializer())();
  return IntSerializer_instance;
}
var BooleanSerializerClass;
function BooleanSerializer() {
  if (BooleanSerializerClass === VOID) {
    class $ {
      constructor() {
        BooleanSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Boolean', BOOLEAN_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_ky3y8o_k$(encoder, value) {
        return encoder.encodeBoolean_tu2e59_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ky3y8o_k$(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeBoolean_m0aca_k$();
      }
    }
    initMetadataForObject($, 'BooleanSerializer', VOID, VOID, [KSerializer()]);
    BooleanSerializerClass = $;
  }
  return BooleanSerializerClass;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new (BooleanSerializer())();
  return BooleanSerializer_instance;
}
var DoubleSerializerClass;
function DoubleSerializer() {
  if (DoubleSerializerClass === VOID) {
    class $ {
      constructor() {
        DoubleSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Double', DOUBLE_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_sc6aif_k$(encoder, value) {
        return encoder.encodeDouble_n270q9_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_sc6aif_k$(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeDouble_ur8l0f_k$();
      }
    }
    initMetadataForObject($, 'DoubleSerializer', VOID, VOID, [KSerializer()]);
    DoubleSerializerClass = $;
  }
  return DoubleSerializerClass;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new (DoubleSerializer())();
  return DoubleSerializer_instance;
}
var LongSerializerClass;
function LongSerializer() {
  if (LongSerializerClass === VOID) {
    class $ {
      constructor() {
        LongSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Long', LONG_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_h2sm9l_k$(encoder, value) {
        return encoder.encodeLong_vlw3uq_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_h2sm9l_k$(encoder, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeLong_jzt186_k$();
      }
    }
    initMetadataForObject($, 'LongSerializer', VOID, VOID, [KSerializer()]);
    LongSerializerClass = $;
  }
  return LongSerializerClass;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new (LongSerializer())();
  return LongSerializer_instance;
}
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().get_wei43m_k$(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer())) ? tmp : THROW_CCE();
}
var ByteSerializerClass;
function ByteSerializer() {
  if (ByteSerializerClass === VOID) {
    class $ {
      constructor() {
        ByteSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Byte', BYTE_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_bqouor_k$(encoder, value) {
        return encoder.encodeByte_6txfee_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_bqouor_k$(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeByte_jzz7je_k$();
      }
    }
    initMetadataForObject($, 'ByteSerializer', VOID, VOID, [KSerializer()]);
    ByteSerializerClass = $;
  }
  return ByteSerializerClass;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new (ByteSerializer())();
  return ByteSerializer_instance;
}
var ShortSerializerClass;
function ShortSerializer() {
  if (ShortSerializerClass === VOID) {
    class $ {
      constructor() {
        ShortSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Short', SHORT_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_s3969x_k$(encoder, value) {
        return encoder.encodeShort_gza6si_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_s3969x_k$(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeShort_jjqk32_k$();
      }
    }
    initMetadataForObject($, 'ShortSerializer', VOID, VOID, [KSerializer()]);
    ShortSerializerClass = $;
  }
  return ShortSerializerClass;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new (ShortSerializer())();
  return ShortSerializer_instance;
}
var FloatSerializerClass;
function FloatSerializer() {
  if (FloatSerializerClass === VOID) {
    class $ {
      constructor() {
        FloatSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Float', FLOAT_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_ttziez_k$(encoder, value) {
        return encoder.encodeFloat_b8b85a_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ttziez_k$(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeFloat_jcnrwu_k$();
      }
    }
    initMetadataForObject($, 'FloatSerializer', VOID, VOID, [KSerializer()]);
    FloatSerializerClass = $;
  }
  return FloatSerializerClass;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new (FloatSerializer())();
  return FloatSerializer_instance;
}
var CharSerializerClass;
function CharSerializer() {
  if (CharSerializerClass === VOID) {
    class $ {
      constructor() {
        CharSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveSerialDescriptor())('kotlin.Char', CHAR_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_i00eow_k$(encoder, value) {
        return encoder.encodeChar_id8ngf_k$(value);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_i00eow_k$(encoder, value instanceof Char() ? value.value_1 : THROW_CCE());
      }
      deserialize_dkqcoq_k$(decoder) {
        return decoder.decodeChar_dcmcfa_k$();
      }
      deserialize_sy6x50_k$(decoder) {
        return new (Char())(this.deserialize_dkqcoq_k$(decoder));
      }
    }
    initMetadataForObject($, 'CharSerializer', VOID, VOID, [KSerializer()]);
    CharSerializerClass = $;
  }
  return CharSerializerClass;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new (CharSerializer())();
  return CharSerializer_instance;
}
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().get_values_ksazhn_k$();
  var _iterator__ex2g4s = values.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var primitive = _iterator__ex2g4s.next_20eer_k$();
    var primitiveName = primitive.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
    if (serialName === primitiveName) {
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).get_simpleName_r6f8py_k$() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new (PrimitiveSerialDescriptor())(serialName, kind);
}
function error($this) {
  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Primitive descriptor ' + $this.serialName_1 + ' does not have elements');
}
var PrimitiveSerialDescriptorClass;
function PrimitiveSerialDescriptor() {
  if (PrimitiveSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, kind) {
        this.serialName_1 = serialName;
        this.kind_1 = kind;
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      get_kind_wop7ml_k$() {
        return this.kind_1;
      }
      get_elementsCount_288r0x_k$() {
        return 0;
      }
      getElementName_u4sqmf_k$(index) {
        error(this);
      }
      getElementIndex_utfbym_k$(name) {
        error(this);
      }
      isElementOptional_heqq56_k$(index) {
        error(this);
      }
      getElementDescriptor_ncda77_k$(index) {
        error(this);
      }
      getElementAnnotations_omrjs6_k$(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.serialName_1 + ')';
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrimitiveSerialDescriptor()))
          return false;
        if (this.serialName_1 === other.serialName_1 && equals(this.kind_1, other.kind_1))
          return true;
        return false;
      }
      hashCode() {
        return getStringHashCode(this.serialName_1) + imul(31, this.kind_1.hashCode()) | 0;
      }
    }
    protoOf($).get_isNullable_67sy7o_k$ = get_isNullable;
    protoOf($).get_isInline_usk17w_k$ = get_isInline;
    protoOf($).get_annotations_20dirp_k$ = get_annotations;
    initMetadataForClass($, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    PrimitiveSerialDescriptorClass = $;
  }
  return PrimitiveSerialDescriptorClass;
}
var UnitSerializerClass;
function UnitSerializer() {
  if (UnitSerializerClass === VOID) {
    class $ {
      constructor() {
        UnitSerializer_instance = this;
        this.$$delegate_0__1 = new (ObjectSerializer())('kotlin.Unit', Unit_instance);
      }
      get_descriptor_wjt6a0_k$() {
        return this.$$delegate_0__1.get_descriptor_wjt6a0_k$();
      }
      serialize_w4s1vx_k$(encoder, value) {
        this.$$delegate_0__1.serialize_kj9hv3_k$(encoder, Unit_instance);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_w4s1vx_k$(encoder, value instanceof Unit() ? value : THROW_CCE());
      }
      deserialize_dkeqa4_k$(decoder) {
        this.$$delegate_0__1.deserialize_sy6x50_k$(decoder);
      }
      deserialize_sy6x50_k$(decoder) {
        this.deserialize_dkeqa4_k$(decoder);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'UnitSerializer', VOID, VOID, [KSerializer()]);
    UnitSerializerClass = $;
  }
  return UnitSerializerClass;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new (UnitSerializer())();
  return UnitSerializer_instance;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
//region block: exports
export {
  BooleanSerializer_getInstance as BooleanSerializer_getInstance22aja3hu17sxf,
  ByteSerializer_getInstance as ByteSerializer_getInstance20v1505to7w0y,
  CharSerializer_getInstance as CharSerializer_getInstancehi0q1kl0h8cw,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance1tuvibnyg07o1,
  FloatSerializer_getInstance as FloatSerializer_getInstance1c6yoefuaocts,
  IntSerializer_getInstance as IntSerializer_getInstance3jyhns9ue706g,
  LongSerializer_getInstance as LongSerializer_getInstancepwtz4tlewrfw,
  ShortSerializer_getInstance as ShortSerializer_getInstance1sui2olw3dzs8,
  StringSerializer_getInstance as StringSerializer_getInstance1p9zda6r6kb23,
  UnitSerializer_getInstance as UnitSerializer_getInstance13j6tqdl8rnmw,
  PrimitiveDescriptorSafe as PrimitiveDescriptorSafe1r3pht5v1oaqu,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptorkwnwsc78b2on,
  builtinSerializerOrNull as builtinSerializerOrNull180kp99qvlpex,
  checkNameIsNotAPrimitive as checkNameIsNotAPrimitive28vmhppr4nskt,
};
//endregion

//# sourceMappingURL=Primitives.mjs.map
